import { Injectable } from '@angular/core';
import { UturuncoUtils } from '../../utils/uturuncoUtils';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DetalleVenta } from 'src/app/model/index.model';
import { BaseService } from './base.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DetalleVentaService extends BaseService<DetalleVenta> {

    constructor(protected override http: HttpClient) {
        super(http, 'detalleVenta');
    }

    getCliente() {
        this.other_header = UturuncoUtils.getHeader();
        return firstValueFrom(this.http
            .get(this.api + "/factory/cliente", { headers: this.other_header }))
    }


    getByCliente(criteria) {
        this.other_header = UturuncoUtils.getHeader();
        return firstValueFrom(this.http
            .get(this.api + "/factory/cliente/" + criteria, { headers: this.other_header }))
    }

    findByUser(user, fe1, fe2) {
        this.other_header = UturuncoUtils.getHeader();

        return firstValueFrom(this.http
            .post(this.api + "/factory/getVentas/", { query: { usuario: user, fechade: fe1, fechaha: fe2 } }, { headers: this.other_header }));
    }

    getVentasByFecha(de, hasta) {
        this.other_header = UturuncoUtils.getHeader();

        let body = {
            "query":
                { "fechade": de, "fechaha": hasta },
        };
        return firstValueFrom(this.http
            .post(this.api + "/factory/getVentasbyFecha/", body, { headers: this.other_header }));
    }
    getVentasByCategoria(de, hasta, descripcion) {

        this.other_header = UturuncoUtils.getHeader();

        let body = {
            "query":
                { "fechade": de, "fechaha": hasta, "descripcion": descripcion },
        };

        return firstValueFrom(this.http
            .post(this.api + "/factory/getVentasbyCategoria/", body, { headers: this.other_header }));
    }

    getVentasByProducto(de, hasta, descripcion) {
        this.other_header = UturuncoUtils.getHeader();
        let body = {
            "query":
                { "fechade": de, "fechaha": hasta, "descripcion": descripcion },
        };
        return firstValueFrom(this.http
            .post(this.api + "/factory/getVentasbyProducto/", body, { headers: this.other_header }));
    }

}
